import Vue from 'vue'
import platform from 'platform'
import { Ws } from '@/services/ws'
import http, { collectOrdersBaseURL } from '@/services/http'

function getSocketQuery() {
  const browserName = platform.name
  const broserVersion = platform.version
  const token = localStorage.getItem('token')
  return `?device_name=${browserName}&app_version=${broserVersion}&token=${token}`
}

function getSocketProtocol() {
  if (location.protocol === 'https:') {
    return 'wss:'
  }
  return 'ws:'
}

function getSocketUrl(rootState, url) {
  const manufactureId = rootState.manufactures.selectedManufacture.id
  return `${getSocketProtocol()}//${window.location.host.replace('weblogist', 'wss')}:8443${url}${manufactureId}${getSocketQuery()}`
}

/**
 * 
 * @param {id: string | number} list 
 */
function getHashTable(list) {
  return list.reduce((acc, item) => {
    acc[item.id] = item
    return acc
  }, {})
}

const getDefaultRemakeRouteTasks = () => ({
  remaking: {},
  not_accepted: {}
})

const checkDeleteRouteTask = (eventData) => {
  return eventData &&
        eventData.action &&
        eventData.action === 'remove_route_task' &&
        eventData.route_task_id !== undefined
}


const socketsHash = {
  collectSocket: '/ws/build/collect/web/',
  // acceptSocket: '/ws/build/accept/web/',
  remakeSocket: '/ws/build/remake/web/'
}

export default {
  namespaced: true,

  state: {
    /* ***COLLECT SOCKET LOGIC*** */
    collectSocket: null,
    /**
     * хеш таблица
     */
    collectRouteTasks: {},
    /* ***END COLLECT SOCKET LOGIC*** */

    /* ***ACCEPT SOCKET LOGIC*** */
    // acceptSocket: null,
     /**
     * хеш таблица
     */
    acceptRouteTasks: {},
    /* ***END ACCEPT SOCKET LOGIC*** */

    /* ***REMAKE SOCKET LOGIC*** */
    remakeSocket: null,
     /**
     * хеш таблицы
     */
    remakeRouteTasks: getDefaultRemakeRouteTasks(),
    /* ***END REMAKE SOCKET LOGIC*** */

    activeSockets: [],
  },

  getters: {
    actionTasksCount(state) {
      const acceptRouteTasks = Object.values(state.acceptRouteTasks)
      const remakingTasks = Object.values(state.remakeRouteTasks.remaking).filter(task => {
        return task.status !== 'in_progress'
      })
      const notAcceptedTasks = Object.values(state.remakeRouteTasks.not_accepted)

      const result = acceptRouteTasks.length + remakingTasks.length + notAcceptedTasks.length
      
      return result
    }
  },

  mutations: {
    /* ***COLLECT SOCKET LOGIC*** */
    SET_COLLECT_SOCKET(state, collectSocket) {
      state.collectSocket = collectSocket
    },
    SET_COLLECT_ROUTE_TASKS(state, collectRouteTasks) {
      state.collectRouteTasks = collectRouteTasks
    },
    PROCESS_COLLECT_ROUTE_TASK(state, data) {
      Vue.set(state.collectRouteTasks, data.id, data)
    },
    /* ***END COLLECT SOCKET LOGIC*** */

    /* ***ACCEPT SOCKET LOGIC*** */
    // SET_ACCEPT_SOCKET(state, acceptSocket) {
    //   state.acceptSocket = acceptSocket
    // },
    SET_ACCEPT_ROUTE_TASKS(state, acceptRouteTasks) {
      state.acceptRouteTasks = acceptRouteTasks
    },
    PROCESS_ACCEPT_ROUTE_TASK(state, data) {
      Vue.set(state.acceptRouteTasks, data.id, data)
    },
    /* ***END ACCEPT SOCKET LOGIC*** */

    /* ***REMAKE SOCKET LOGIC*** */
    SET_REMAKE_SOCKET(state, remakeSocket) {
      state.remakeSocket = remakeSocket
    },
    SET_REMAKE_ROUTE_TASKS(state, remakeRouteTasks) {
      state.remakeRouteTasks = remakeRouteTasks
    },
    PROCESS_REMAKE_ROUTE_TASK(state, data) {
      if (data.stage !== undefined) {
        Vue.set(state.remakeRouteTasks[data.stage], data.route_task.id, data.route_task)
      }
    },
    /* ***END REMAKE SOCKET LOGIC*** */

    /* ***ACTIVE SOCKET LOGIC*** */
    ADD_ACTIVE_SOCKET(state, socket) {
      state.activeSockets = [...state.activeSockets, socket]
    },
    REMOVE_ACTIVE_SOCKET(state, socket) {
      state.activeSockets = state.activeSockets.filter(s => s !== socket)
    },
    /* ***END ACTIVE SOCKETS LOGIC*** */

    /**
     *
     * @param { path: array, routeTaskId } data 
     */
    DELETE_ROUTE_TASK(state, data) {
      /**
       * здесь будет ссылка
       */
      let processesObj = state
      const { path, routeTaskId } = data
      for (let i = 0; i < path.length; i++) {
        const part = path[i]
        processesObj = processesObj[part]
        if (!processesObj) {
          break
        }
      }
      if (processesObj) {
        Vue.delete(processesObj, routeTaskId)
      }
    }
  },
  
  actions: {
    setConnection ({ state, rootState, commit, dispatch }, { field, mutationField, onMessage }) {
      const selectedManufacture = rootState.manufactures.selectedManufacture
      if (!selectedManufacture) return

      if (state[field]) {
        state[field].close()
      }
      const url = socketsHash[field]
      const fullUrl = getSocketUrl(rootState, url)

      const socketInstance = new Ws(fullUrl, {
        onOpen: () => {
          commit('ADD_ACTIVE_SOCKET', socketInstance)
        },
        onEvent: event => {
          if (!event.message) {
            onMessage(event)
          } else {
            commit('serverErrors/ADD_ERROR', event.message, { root: true })
          }
          
        },
        onErrorClose: () => {
          setTimeout(() => {
            dispatch('setConnection', { field, mutationField, onMessage })
          }, 1000)
        }
      })

      commit(mutationField, socketInstance)
    },

    closeSocketConnections({ state }) {
      state.activeSockets.forEach(socket => socket.close())
    },
    async makeSocketConnections( ) {
      await this.setAcceptConnection()
    },

    setCollectConnection({ commit, dispatch }) {
      const onMessage = data => {
        if (data.list) {
          commit('SET_COLLECT_ROUTE_TASKS', getHashTable(data.list))
        } else {
          commit('PROCESS_COLLECT_ROUTE_TASK', data)
        }
      }

      dispatch('setConnection', {
        field: 'collectSocket',
        mutationField: 'SET_COLLECT_SOCKET',
        onMessage
      })
    },

    setRemakeConnection({ state, commit, dispatch }) {

      const onMessage = data => {
        if (checkDeleteRouteTask(data)) {
          Object.keys(state.remakeRouteTasks).forEach(key => {
            commit('DELETE_ROUTE_TASK', {
              path: ['remakeRouteTasks', key],
              routeTaskId: data.route_task_id
            })
          })
        } else if (data.remaking && data.not_accepted) {
          commit('SET_REMAKE_ROUTE_TASKS', {
            remaking: getHashTable(data.remaking),
            not_accepted: getHashTable(data.not_accepted)
          })
        } else {
          commit('PROCESS_REMAKE_ROUTE_TASK', data)
        }
      }

      dispatch('setConnection', {
        field: 'remakeSocket',
        mutationField: 'SET_REMAKE_SOCKET',
        onMessage
      })
    },

    async getOrdersToRemake({ commit }, routeTaskId) {
      try {
        commit('pageLoader/SET_LOADING', true, { root: true })
        const res = await http({
          url: `route_task/${routeTaskId}`,
          baseURL: collectOrdersBaseURL,
        })
        return res.list
      } finally {
        commit('pageLoader/SET_LOADING', false, { root: true })
      }
    },

    clearRouteTasks({ state, commit }, ) {
      Object.keys(socketsHash).forEach(socketField => {
        if (state[socketField]) {
          state[socketField].close()
        }
      })
      commit('SET_COLLECT_ROUTE_TASKS', {})
      commit('SET_REMAKE_ROUTE_TASKS', getDefaultRemakeRouteTasks())
    }
  }
}